import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChangeInfoService {

  constructor(private http: HttpClient) { }

  ReadDeviceChangeHistory(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/change/read/all`, params);
  }

  UpdateNodeLevel(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/order/update/node`, params);
  }

  ReadCountryList(): Observable <any> {
    return this.http.get<any>(`${environment.apiSerivceUrl}/Personal/api/Service/ReadWebsiteCountryList`);
  }
}
